import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import createSagaMiddleware from "@redux-saga/core";
import thunk from "redux-thunk";

import rootSaga from "./saga";
import { userReducer } from "Features/user";
import { errorReducer } from "Features/error";
import { countryListReducer, timezoneReducer, userMailsReducer } from "Features/utils";
import { authReducer } from "Features/auth";
import { balanceReducer } from "Features/balance";
import { walletReducer } from "Features/wallets";
import { payHistoryReducer } from "Features/pay_history";
import { languageReducer } from "Shared/store/language";
import { withdrawReducer } from "Shared/store/withdraw";
import { taxReducer } from "Pages/Withdraw/store";

const utils = combineReducers({
	user_mails: userMailsReducer,
	country_list: countryListReducer,
	timezone: timezoneReducer,
	auth: authReducer,
});

const wallet = combineReducers({
	balance: balanceReducer,
	wallets: walletReducer,
});

const reducers = combineReducers({
	user: userReducer,
	wallet,
	utils,
	payment_history: payHistoryReducer,
	error: errorReducer,
	language: languageReducer,
	withdraw: withdrawReducer,
	tax: taxReducer,
});

const saga = createSagaMiddleware();

const persistConfig = {
	key: "tpc_lk",
	storage,
	debug: true,
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
	reducer: persistedReducer,
	// eslint-disable-next-line no-undef
	devTools: process.env.NODE_ENV !== "production",
	middleware: [thunk, saga],
});
saga.run(rootSaga);

export default store;
